@if (user) {
    <form [formGroup]="editUserForm">
        @if (userIsAdmin) {
            <div class="inputGroup">
                <span class="label">{{ 'users.supplierUsers.edit.basic.companyName' | translate }}</span>
                <div class="inputWrapper">
                    <app-form-error [parentForm]="editUserForm" [controlPath]="'companyName'" />
                    <input type="text" id="supplierName" disabled [value]="user.companyName" trimInput />
                </div>
            </div>
        }
        <div class="inputGroup">
            <span class="label">{{ 'users.supplierUsers.edit.basic.email' | translate }}</span>
            <div class="inputWrapper">
                <app-form-error [parentForm]="editUserForm" [controlPath]="'email'" />
                <input type="email" id="email" disabled [value]="user.email" />
            </div>
        </div>
        <div class="inputGroup">
            <label for="firstName">{{ 'users.supplierUsers.edit.basic.firstName' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error [parentForm]="editUserForm" [controlPath]="'firstName'" />
                <input type="text" id="firstName" formControlName="firstName" trimInput />
            </div>
        </div>
        <div class="inputGroup">
            <label for="lastName">{{ 'users.supplierUsers.edit.basic.lastName' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error [parentForm]="editUserForm" [controlPath]="'lastName'" />
                <input type="text" id="lastName" formControlName="lastName" trimInput />
            </div>
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.supplierUsers.edit.basic.status' | translate }}</span>
            <span>{{ user.status }}</span>
        </div>
        <div class="inputGroup">
            <label for="doNotEmail" class="label">{{ 'users.supplierUsers.edit.basic.doNotEmail' | translate }}</label>
            <input type="checkbox" id="doNotEmail" formControlName="doNotEmail" />
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.supplierUsers.edit.basic.lastLogin' | translate }}</span>
            <span>{{ user.lastLogin | date: 'MMMM d, yyyy HH:mm' }}</span>
        </div>
        @if (notifications && notifications.length !== 0) {
            <div class="inputGroup labelTop">
                <span class="label">{{ 'users.supplierUsers.edit.basic.notificationControl' | translate }}</span>
                <div class="checkboxWrapper rows">
                    @for (notification of notifications; track notification) {
                        <div class="notificationWrapper" [formGroupName]="'notificationSettings'" id="notificationSettings">
                            <input type="checkbox" id="{{ notification.id }}" [formControlName]="notification.id" />
                            <label class="noFixedWidth noDisplaySet" for="{{ notification.id }}">
                                {{ 'myUserProfile.notifications.' + notification.notificationType | translate }}
                            </label>
                        </div>
                    }
                </div>
            </div>
        }
        <div class="inputGroup">
            <label for="isEnabled">{{ 'users.supplierUsers.edit.basic.enabled' | translate }}</label>
            <input type="checkbox" id="isEnabled" formControlName="isEnabled" />
        </div>
        <div class="inputGroup">
            <label for="passwordChangeRequired">{{ 'users.supplierUsers.edit.basic.requirePasswordChange' | translate }}</label>
            <input type="checkbox" id="passwordChangeRequired" formControlName="passwordChangeRequired" />
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.supplierUsers.edit.basic.createdBy' | translate }}</span>
            <span class="underline">{{
                user.entityTracking.createdBy ? user.entityTracking.createdBy : ('users.userUnavailable' | translate)
            }}</span>
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.supplierUsers.edit.basic.createdOn' | translate }}</span>
            <span>{{ user.entityTracking.createdAt | date: 'MMMM d, yyyy HH:mm' }}</span>
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.supplierUsers.edit.basic.modifiedBy' | translate }}</span>
            <span class="underline">{{
                user.entityTracking.modifiedBy ? user.entityTracking.modifiedBy : ('users.userUnavailable' | translate)
            }}</span>
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.supplierUsers.edit.basic.modifiedOn' | translate }}</span>
            <span>{{ user.entityTracking.modifiedAt | date: 'MMMM d, yyyy HH:mm' }}</span>
        </div>
    </form>
}
